import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header flex">
          <a className="navbar-brand page-scroll truncate" href="#page-top">
            广州润钢软件科技有限公司
          </a>{" "}
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
        </div>
        <div
          className="!visible collapse navbar-collapse "
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll">
                优势
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                产品
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                关于
              </a>
            </li>
            {/* <li>
              <a href="#portfolio" className="page-scroll">
                画廊
              </a>
            </li> */}
            {/* <li>
              <a href="#testimonials" className="page-scroll">
                评价
              </a>
            </li> */}
            {/* <li>
              <a href="#team" className="page-scroll">
                团队
              </a>
            </li> */}
            <li>
              <a href="#contact" className="page-scroll">
                联系
              </a>
            </li>
            <li>
              <a
                href="https://hailuo.rg-software.com/"
                className="page-scroll"
                target="_blank"
              >
                海螺编程
              </a>
            </li>
            <li>
              <a
                href="https://erp.rg-software.com/"
                className="page-scroll"
                target="_blank"
              >
                ERP系统
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
